module.exports = __webpack_public_path__ + "assets/svg/spatial-audio-logo-micro.svg";